import LocationsListPage from './LocationsListPage';
export default LocationsListPage;